import styled from 'styled-components';
import tw, { classnames, backgroundColor, flexWrap, padding, borderRadius, alignContent, fontWeight, fontSize, textColor, space, divideWidth, divideColor } from 'tailwindcss-classnames';

export const Container = styled.div.attrs({
    className: classnames(flexWrap('flex-wrap'), padding('px-4', 'pt-3', 'pb-4'), borderRadius('rounded-b-md'))
})``;

export const Header = styled.div.attrs({
    className: classnames(backgroundColor('bg-gpas-100' as any, 'dark:bg-gpas-700' as any), flexWrap('flex-wrap'), alignContent('content-center'), padding('px-4', 'pt-2'))
})``;

export const Title = styled.h3.attrs({
    className: classnames(textColor('text-gpas-700' as any, 'dark:text-white' as any), fontWeight('font-bold'), fontSize('text-2xl'), padding('pb-0'))
})``;

export const Content = styled.div.attrs({
    className: classnames(flexWrap('flex-wrap'), space('space-y-6'), divideWidth('divide-y', 'divide-y-2'), divideColor('divide-gray-200'))
})``;
